var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.main_cont_class],style:(_vm.user_app_custom_styles),attrs:{"id":"tmbooking_user_app"}},[_c('IconFillSVG'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }